import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { FuncionarioService } from "src/app/shared/services/funcionario.service";
import { funcionarioActions } from "./funcionario.actions";
import { catchError, concat, concatMap, exhaustMap, map, of, tap } from "rxjs";
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()

export class FuncionarioEffects {

    constructor(
        private service: FuncionarioService,
        private notify: NotifyService,
        private action$: Actions
    ) { }

    loadFuncionario$ = createEffect(() =>
        this.action$.pipe(
            ofType(funcionarioActions.loadFuncionario),
            exhaustMap(({ totalPages = "" }) =>
                this.service
                    .get(totalPages)
                    .pipe(
                        map((res) => funcionarioActions.loadFuncionarioSuccess({ lista: res })),
                        catchError((error) => {
                            //this.notify.emitError('Falha ao carregar registros')
                            return of(funcionarioActions.loadFuncionarioError())
                        })
                    )

            )
        )
    )

    saveFuncionario$ = createEffect(() =>
        this.action$.pipe(
            ofType(funcionarioActions.saveFuncionario),
            concatMap(
                ({ funcionario }) =>
                    this.service.post(funcionario).pipe(
                        tap(() => this.notify.saveSuccess()),
                        map(() => funcionarioActions.saveFuncionarioSuccess()),
                        catchError(
                            (error) => {
                                //this.notify.emitError(error.error['hydra:description']);
                                return of(funcionarioActions.saveFuncionarioError())
                            }
                        )
                    )
            )
        )

    )

    editFuncionario$ = createEffect(() =>
        this.action$.pipe(
            ofType(funcionarioActions.editFuncionario),
            concatMap(
                ({ funcionario, id }) =>
                    this.service
                        .edit(funcionario, id)
                        .pipe(
                            tap(() => this.notify.editSuccess()),
                            map(() => funcionarioActions.editFuncionarioSuccess()),
                            catchError((error) => {
                                //this.notify.emitError(error.error['hydra:description'])
                                return of(funcionarioActions.editFuncionarioError())
                            })
                        )
            )
        )
    );


    deleteFuncionario$ = createEffect(() =>
        this.action$.pipe(
            ofType(funcionarioActions.deleteFuncionario),
            concatMap(
                ({ id }) =>
                    this.service.delete(id).pipe(
                        tap(() => this.notify.deleteSuccess()),
                        map((res) => funcionarioActions.loadFuncionario()),

                        catchError((error) => {
                            //this.notify.emitError(error.error['hydra:description']);
                            return of(error.error['hydra:description']);
                        }

                        )
                    )
            )
        )
    )

}
